'use client';

import useSWR from 'swr';

import type { OpenRouterModel } from '@/ai/model/openrouter-models';

type ModelsResponse = { models: OpenRouterModel[] };

const fetcher = async (url: string): Promise<ModelsResponse> => {
  const response = await fetch(url);
  if (!response.ok) throw new Error('Não foi possível carregar os modelos.');
  return response.json() as Promise<ModelsResponse>;
};

export function useOpenRouterModels() {
  // The model catalog is near-static and large (~238 kB), and this hook
  // mounts in several widgets per page (launcher, chat panel, settings).
  // Without these options every mount refetched the full list — 3x per
  // navigation in production. SWR keeps one copy in browser memory and
  // the route also sends Cache-Control, so re-fetches within the HTTP
  // TTL are served by the browser without touching the server.
  const { data, isLoading } = useSWR<ModelsResponse>('/api/ai/models', fetcher, {
    revalidateOnFocus: false,
    revalidateIfStale: false,
    dedupingInterval: 3600_000,
  });
  const models = data?.models ?? [];
  return {
    models,
    isLoading,
    getModel: (id: string) => models.find((model) => model.id === id),
  };
}
